export const trackSiteVisit = () => console.log("Site visit tracked");
